import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'
import {createActionObject} from '../../../redux/utils'
import * as UserManagementSyncCallbacks from '../syncCallbacks'
import {saveActiveTabNum} from './utils'
import {toast} from '../../../toasts/actions'
import messageResource from '../../../messageResource'
import {HierarchyLevels} from 'constants'
import {EXCEPTIONS} from '../../../panels/user/editPanel/util'
import {removeUser} from '../../../entities/actions'
import * as SyncCallbacks from '../../../panels/user/editPanel/syncCallbacks'
import RpcError from '../../../util/rpc/RpcError'

export const setActiveTabAction = (tabNum) => dispatch => {
    dispatch(createActionObject(ActionTypes.SET_ACTIVE_TAB, tabNum))
    saveActiveTabNum(tabNum)

    UserManagementSyncCallbacks.triggerActiveTabChanged(tabNum)
}

export const setViewerSettings = createAction(ActionTypes.SET_VIEWER_SETTINGS)
export const setUserManagementData = createAction(ActionTypes.USER_MANAGEMENT_DATA_SET)
export const setUsersWithoutApprovers = createAction(ActionTypes.SET_USERS_WITHOUT_APPROVERS)
export const setLicenseCounters = createAction(ActionTypes.SET_LICENSE_COUNTERS)
export const setNewUserIdSet = createAction(ActionTypes.SET_NEW_USER_IDS)
export const addNewUserIds = createAction(ActionTypes.ADD_NEW_USER_IDS)
export const setViewerManagementAssignmentsCounters = createAction(ActionTypes.SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS)
export const addNewUsersToList = createAction(ActionTypes.USERS_LIST_ADD)
export const setUserList = createAction(ActionTypes.USERS_LIST_SET)
export const removeUserFromList = createAction(ActionTypes.USERS_LIST_REMOVE)
export const closeAllPanels = createAction(ActionTypes.CLOSE_ALL_PANELS)
export const updateUsersListUserGroupId = createAction(ActionTypes.USERS_LIST_USER_GROUP_ID_UPDATE)

export const handleKeptMaAfterRemoveWaByToast = ({cptWaChangesFlags, level, all = false}) => (dispatch) => {
    if (!cptWaChangesFlags.customersKept && !cptWaChangesFlags.projectsKept && !cptWaChangesFlags.tasksKept && !cptWaChangesFlags.noDeletions) return

    let levelName = ""
    let levelNames = ""

    switch (level) {
        case HierarchyLevels.CUSTOMER:
            levelName = messageResource.getMessage('common.customer')
            levelNames = messageResource.getMessage('common.customers')
            break
        case HierarchyLevels.PROJECT:
            levelName = messageResource.getMessage('common.project')
            levelNames = messageResource.getMessage('common.projects')
            break
        case HierarchyLevels.TASK:
            levelName = messageResource.getMessage('common.task')
            levelNames = messageResource.getMessage('common.tasks')
            break
    }

    if (!!cptWaChangesFlags) {
        if (all && cptWaChangesFlags.noDeletions) {
            dispatch(toast(messageResource.getMessage(
                'assigned_users_editor.work.toast.revoke_all.wa_kept_as_ma',
                [levelNames]
            )))
            return
        }

        let maItemLevelNames
        if (cptWaChangesFlags.customersKept && cptWaChangesFlags.projectsKept && cptWaChangesFlags.tasksKept) {
            maItemLevelNames = messageResource.getMessage('common.customers') +
                               ", " +
                               messageResource.getMessage('common.projects') +
                               " and " +
                               messageResource.getMessage('common.tasks')
        } else if (cptWaChangesFlags.projectsKept && cptWaChangesFlags.tasksKept) {
            maItemLevelNames = messageResource.getMessage('common.projects') +
                               " and " +
                               messageResource.getMessage('common.tasks')
        } else if (cptWaChangesFlags.customersKept && cptWaChangesFlags.projectsKept) {
            maItemLevelNames = messageResource.getMessage('common.customers') +
                               " and " +
                               messageResource.getMessage('common.projects')
        } else if (cptWaChangesFlags.customersKept && cptWaChangesFlags.tasksKept) {
            maItemLevelNames = messageResource.getMessage('common.customers') +
                               " and " +
                               messageResource.getMessage('common.tasks')
        } else if (cptWaChangesFlags.customersKept) {
            maItemLevelNames = messageResource.getMessage('common.customers')
        } else if (cptWaChangesFlags.projectsKept) {
            maItemLevelNames = messageResource.getMessage('common.projects')
        } else if (cptWaChangesFlags.tasksKept) {
            maItemLevelNames = messageResource.getMessage('common.tasks')
        }

        if (all) {
            dispatch(toast(messageResource.getMessage(
                'assigned_users_editor.work.toast.revoke_all.wa_kept_as_ma',
                [maItemLevelNames]
            )))
        } else if (cptWaChangesFlags.noDeletions) {
            dispatch(toast(messageResource.getMessage(
                'assigned_users_editor.work.toast.all_wa_kept_as_ma',
                [levelName, maItemLevelNames]
            )))
        } else {
            dispatch(toast(messageResource.getMessage(
                'assigned_users_editor.work.toast.some_wa_kept_as_ma',
                [levelName, maItemLevelNames]
            )))
        }
    }
}

export const handleCommonError = (userId, error) => dispatch => {
    if (error instanceof  RpcError) {
        switch (error.getException()) {
            case EXCEPTIONS.NoSuchUserException:
                alert(messageResource.getMessage('user.js.error_user_was_deleted'))
                dispatch(removeUser(userId))
                SyncCallbacks.onNoSuchUserException(userId)
                break
            case EXCEPTIONS.NoRightsToManageAccountSettings:
                alert(messageResource.getMessage('userlist.js.error_manage_account_settings_right_revoked'))
                window.location.reload()
                break
            default:
                console.error(error)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/common/actions.js